import { render, staticRenderFns } from "./PaymentsHistory.vue?vue&type=template&id=edc533fc&scoped=true"
import script from "./PaymentsHistory.vue?vue&type=script&lang=js"
export * from "./PaymentsHistory.vue?vue&type=script&lang=js"
import style0 from "./PaymentsHistory.vue?vue&type=style&index=0&id=edc533fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc533fc",
  null
  
)

export default component.exports